import type { IntlShape } from 'react-intl';

import type { EditorActions } from '@atlaskit/editor-core/actions';
import type { ToolbarItem } from '@atlaskit/editor-common/extensions/extension-manifest-toolbar-item';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

import type { ExtensionHandlerWithReferenceFn } from '@atlassian/editor-referentiality/types';

import { parseNumber } from './parseNumber.ts';
import type { ExtensionManifest } from '@atlaskit/editor-common/extensions';

type CreateChartsExtensionProps = {
	intl: IntlShape;
	editorActions?: EditorActions;
	extensionHandlers?: ExtensionHandlerWithReferenceFn<any>;
	createAnalyticsEvent?: CreateUIAnalyticsEvent;
	externalToolbarItems?: ToolbarItem[];
};

export const createChartsExtension = async ({
	intl,
	editorActions,
	extensionHandlers,
	createAnalyticsEvent,
	externalToolbarItems,
}: CreateChartsExtensionProps): Promise<ExtensionManifest> => {
	const { buildManifest } = await import(
		/* webpackChunkName: "loadable-atlassiancharts" */ '@atlassian/charts'
	);
	return buildManifest({
		intl: intl as any,
		editorActions,
		parseNumber,
		extensionHandlerWithReference: extensionHandlers,
		createAnalyticsEvent,
		externalToolbarItems: externalToolbarItems || [],
	});
};
